/**
 * @fileoverview Receipt and invoice management actions
 * @module ReceiptsActions
 */

import apiClient from "../utils/apiClient";

/**
 * Obtains all available receipts/invoices
 * @function
 * @name getReceipts
 * @memberof module:ReceiptsActions
 * @returns {Promise<Object|undefined>} Receipt data or undefined if error
 */
export const getReceipts = async () => {
  try {
    const response = await apiClient.get("/invoices");
    return response;
  } catch (err) {
    $log.error(err);
  }
};
